<template>
  <div class="animated fadeIn">
   
    <b-alert variant="primary" show dismissible >
      Welcome to Cashbac UI! Please note: <b>This project no longer maintained</b>.
    </b-alert>

    <b-card class="card-with-bg-cb">
      <b-card-body>
        <h1>
          Cashbac UI
        </h1>
        <br />
        <p class="sub-headline">
          This is a collection of guidelines and components which can be used to create amazing user experiences. 
          Foundations introduces you to Cashbac's principles while Components lists out the bits and pieces that make up Cashbac Design System.
        </p>

      </b-card-body>
    </b-card>

    
    <b-card-group deck>
      
        <b-card sm="6" md="4">
          <i class="icon-layers icons font-2xl d-block mt-4" ></i>
          <p> </p>
          <h3>Foundations</h3>
          <p> Know the foundations how to use Cashbac UI, to build web products at Cashbac.</p>
          <p> </p>
          <b-button size="lg" variant="outline-primary" block to="/foundation/" class="align-self-end">Get Started</b-button>
        </b-card>
      
        <b-card sm="6" md="4">
          <i class="icon-puzzle icons font-2xl d-block mt-4"></i>
          <p> </p>
          <h3>Components</h3>
          <p>Get to know components in Cashbac UI. Please read one by one carefully :)</p>
          <p></p>
          <b-button size="lg" variant="outline-primary" block to="/components/" class="btn-flex-end align-self-end">See Components</b-button>  
        </b-card>

        <b-card sm="6" md="4">
          <i class="icon-docs icons font-2xl d-block mt-4"></i>
          <p> </p>
          <h3>Page Sample</h3>
          <p> Various page samples that developed for best practice using Cashbac UI</p>
          <p></p>  
            <b-button size="lg" variant="outline-primary" block to="/dashboard" class="btn-flex-end align-self-end">See Samples</b-button>

        </b-card>
    </b-card-group>
    <div class="spacer1"></div>
    <!-- ROW 2 -->
    <b-card-group deck>
        <b-card sm="6" md="4">
          <i class="icon-directions icons font-2xl d-block mt-4"></i>
          <p> </p>
          <h3>Roadmap</h3>
          <p> Current progress, next quarter plans and future dreams. All plans in one roof.</p>
          <p></p>
          <b-button size="lg" variant="outline-primary" block to="/roadmap">See Roadmap</b-button>
        </b-card>

      
        <b-card sm="6" md="4">
          <i class="icon-shield icons font-2xl d-block mt-4"></i>
          <p> </p>
          <h3 style="display: inline-block;">Brand Guidelines</h3>
          <p> Know the brand guidelines of Cashbac. From logo, assets and beyonds.</p>
          <p> </p>
          <b-button size="lg" variant="outline-primary" block to="/brand">Read Guidelines</b-button>
        </b-card>
      
        <b-card sm="6" md="4">
          <i class="icon-bubbles icons font-2xl d-block mt-4"></i>
          <p> </p>
          <h3 style="display: inline-block;">Voice and Tones</h3> &nbsp <b-badge style="display: inline-block; vertical-align: 50%;" variant="info">Coming Soon</b-badge>
          <p>Get to know components in Cashbac UI. Please read one by one carefully :)</p>
          <p></p>
          <b-button size="lg" variant="outline-primary disabled" block>See Voice and Tones</b-button>  
        </b-card>
    </b-card-group>
    
  </div>
</template>

<script>
export default {
  name: 'welcome'
}
</script>
